import Expandable from "../common/expandable";

const Section = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => {
  return (
    <div className="flex flex-col items-start self-stretch group">
      <Expandable>
        <Expandable.Trigger className="flex py-2 px-3 justify-center items-center gap-3 self-stretch rounded-sm bg-blue-200 hover:bg-blue-100 active:bg-blue-300 group transition-colors duration-50">
          <img
            src="/icons/ui/expand-triangle-black.svg"
            alt="expand_triangle_icon"
            className="w-4 h-4 fill-neutral-950 transition-transform duration-200 group-data-[state=closed]:-rotate-90"
          />
          <span className="text-left heading-1-semibold overflow-hidden text-ellipsis whitespace-nowrap flex-1 text-primary">
            {title}
          </span>
          <div className="w-5 h-5 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin opacity-0 group-has-[.loading-spinner]:opacity-100" />
        </Expandable.Trigger>
        <Expandable.Content className="w-full">{children}</Expandable.Content>
      </Expandable>
    </div>
  );
};

export default Section;
